// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FF-z","twoColumnImage":"GF-z"};